// libs
import React from 'react';

// components
import { Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';

// utils
// types
import { ScormOption } from './types';

export const renderOption = (option: ScormOption) => {
  return (
    <Stack alignItems="center" gapX={12}>
      {option.image ? <Image alt="" height={32} src={option.image} width={32} /> : null}
      <Typography className="flex-shrink-0" color="text-text-secondary" variant="body-short-01">
        {option.title}
      </Typography>
    </Stack>
  );
};
